module.exports = {
  "userView": {
    "name": "user view",
    "class": "view",
    "properties": {
      "userId": "number",
      "viewedUserId": "number"
    }
  },
  "userEdit": {
    "name": "user edit",
    "class": "interaction",
    "properties": {
      "userId": "number"
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./events.yaml
// module id = 409
// module chunks = 0